
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BaseEmailPart extends Vue {
  @Prop() modal!: boolean;
  @Prop() complete!: boolean;
  @Prop() incorrect!: boolean;
  @Prop() arrowLeft!: boolean;
}
